import * as React from 'react'
import { Icon, Tag } from 'antd'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import ShellBreadcrumb from './shell-breadcrumb'

interface ContentHeaderProps extends RouteComponentProps {
    title: string,
    subtitle?: string,
    type?: string,
    showBack?: boolean,
    showBackLink?: string
    icon?: string,
    hideBreadcrumb?: boolean
    tags?: string[]
}

class ContentHeader extends React.Component<ContentHeaderProps, any> {
    public render() {
        return <div className="content-header">
            <div>
                {this.props.type && <span className="content-header-type" style={{ textTransform: 'uppercase', fontSize: 16 }}>{this.props.type}</span>}
                {this.props.icon && <Icon type='user' style={{ float: 'left', fontSize: 36, marginTop: 5 }} />}
                <div style={{ marginLeft: this.props.icon ? 50 : 0, marginTop: this.props.type ? -2 : 0 }}>
                    <h3 style={{ marginBottom: 0 }}>{this.props.showBack && <><Icon type='left-circle' style={{ cursor: 'pointer', fontSize: '26px' }} onClick={() => { if (this.props.showBackLink) { this.props.history.push(this.props.showBackLink, this.props.location.state) } else this.props.history.goBack() }}></Icon><span>&nbsp;</span></>}{this.props.title} {this.props.tags && this.props.tags.map(tag => <Tag key={tag} color='#2db7f5'>{tag}</Tag>)}</h3>
                    {this.props.subtitle && <span className="content-header-type" style={{ textTransform: 'uppercase', fontSize: 16 }}>{this.props.subtitle}</span>}
                    {
                        !this.props.hideBreadcrumb && <ShellBreadcrumb />
                    }
                </div>
            </div>
        </div>
    }
}
export default withRouter(ContentHeader)